import type { ApiResponse } from '../models/ApiResponse';
import type FileUploadResponse from '../models/FileUploadResponse';
import BaseService from './BaseService';

class FileService extends BaseService {
  public static MAX_SIZE = 100 * 1024 * 1024;

  public static uploadFile(file: File | File[], progresCb: (progress: number) => void): Promise<ApiResponse<FileUploadResponse[]>> {
    return this.postFile('/v1/files', 'files', file, progresCb);
  }

  public static deleteFile(fileId: string): Promise<ApiResponse<boolean>> {
    return this.delete(`/v1/files/${fileId}`);
  }

  public static updateFriendlyName(fileId: string, name: string): Promise<ApiResponse<boolean>> {
    return this.put(`/v1/files/${fileId}`, { friendlyName: name });
  }

  public static async getFile(fileId: string): Promise<Blob> {
    const res = await this.get<Blob>(`/v1/files/${fileId}`, { responseType: 'arraybuffer' });

    if (res.status !== 200) {
      // eslint-disable-next-line no-throw-literal
      throw { ...res, messsage: `Could not load file ${fileId}.` };
    }

    const fileContent = res.data;
    const fileType = res.headers['content-type']?.toString();

    return new Blob([fileContent], { type: fileType });
  }
}

export default FileService;
